import request from '../../../request'

export default {
  actions: {
    getPackages() {
      return request.get('packages')
    },

    /**
     * Payments
     */
    pay(_, payload) {
      return request.post('pay', payload);
    }
  }
};
